<template>
  <a class="specials__special-box-link" :href="`/announcements/${specialId}`">
    <div class="specials__special-box">
      <img
        class="specials__special-box__image"
        :src="imageUrl"
        alt="specialId"
      />
      <div class="specials__special-box__text">
        <p class="specials__special-box__date">
          {{ startedAt }}
        </p>
        <p class="specials__special-box__title">
          {{ specialTitle }}
        </p>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    specialId: {
      type: Number,
      required: true
    },
    specialTitle: {
      type: String,
      required: true
    },
    startedAt: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  }
}
</script>
